export const ERR_CODE_DUPLICATE_COMPANY_HASH = "1UC6SPLuzECW53IstKy4s";

export const OOPS_SOMETHING_WENT_WRONG = "Oops! something went wrong.";
